/**
 * Created by winner on 8/23/18.
 */
'use strict'

import Vue from 'vue'
import Vuex from 'vuex'
import { db } from '../main'
import * as firebase from 'firebase'
import 'firebase/firestore'
import router from '@/router'
const arrayToObject = (array) =>
  array.reduce((obj, item) => {
    obj[item.productName] = item
    return obj
  }, {})

Vue.use(Vuex)
export const store = new Vuex.Store({
  state: {
    user: null,
    shoppingCart: [],
    shoppingCarts: [],
    products: [],
    producers: [],
    producerNamesArray: [],
    ranges: [],
    categoryNamesArray: [],
    isLoading: false,
    publicDataLoaded: false
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
    },
    setProducer (state, payload) {
      state.producers = payload
    },
    setProduct (state, payload) {
      state.products = payload
    },
    setProducerNamesArray (state, payload) {
      state.producerNamesArray = payload
    },
    setCategory (state, payload) {
      state.ranges = payload
    },
    setCategoryNamesArray (state, payload) {
      state.categoryNamesArray = payload
    },
    setLoading (state, payload) {
      state.isLoading = payload
    },
    setShoppingCart (state, payload) {
      state.shoppingCart = payload
    },
    setPublicDataLoaded (state) {
      state.publicDataLoaded = true
    }
  },
  actions: {
    // A realtime listener to the producers collection
    initRealTimeProducersListeners ({commit, state}) {
      db.collection('producers').onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if (change.type === 'added') {
            console.log('New Producer :  ' + JSON.stringify(change.doc.data()))
            db.collection('producers').get().then(function (querySnapshot) {
              const data = []
              const producerNameData = []
              querySnapshot.forEach(function (doc) {
                const values = doc.data()
                const producersNames = doc.data().producerName
                data.push(values)
                producerNameData.push(producersNames)
              })
              commit('setProducer', data)
              commit('setProducerNamesArray', producerNameData)
            }).catch(function (error) {
              console.log(error)
            })
          }
          if (change.type === 'modified') {
            console.log('Producer data modified :  ' + JSON.stringify(change.doc.data()))
          }
          if (change.type === 'removed') {
            console.log('Producer data removed :  ' + JSON.stringify(change.doc.data()))
            db.collection('producers').get().then(function (querySnapshot) {
              const data = []
              querySnapshot.forEach(function (doc) {
                const values = doc.data()
                data.push(values)
              })
              commit('setProducer', data)
            }).catch(function (error) {
              console.log(error)
            })
          }
        })
      })
    },
    // Get all documents in the producers collection
    fetchProducers ({commit}) {
      db.collection('producers').get().then(function (querySnapshot) {
        const data = []
        const producerNameData = []
        querySnapshot.forEach(function (doc) {
          const values = doc.data()
          const producersNames = doc.data().producerName
          data.push(values)
          producerNameData.push(producersNames)
        })
        commit('setProducer', data)
        commit('setPublicDataLoaded')
      }).catch(function (error) {
        console.log(error)
      })
    },
    FECTH_PRODUCTS ({commit}) {
      db.collection('products').get().then(function (querySnapshot) {
        const data = []
        querySnapshot.forEach(function (doc) {
          const values = doc.data()
          data.push(values)
        })
        commit('setProduct', data)
        commit('setPublicDataLoaded')
      }).catch(function (error) {
        console.log(error)
      })
    },
    fetchCategory ({commit}) {
      db.collection('categories').get().then(function (querySnapshot) {
        const data = []
        const categoryData = []
        querySnapshot.forEach(function (doc) {
          const values = doc.data()
          const categoryValuesNames = doc.data().name
          data.push(values)
          categoryData.push(categoryValuesNames)
        })
        commit('setCategory', data)
        commit('setCategoryNamesArray', categoryData)
        commit('setPublicDataLoaded')
      }).catch(function (error) {
        console.log(error)
      })
    },
    SIGNUP_USER ({commit, getters}, payload) {
      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then((user) => {
          let auth = firebase.auth().currentUser.uid
          db.collection('users').doc(auth).set({
            names: payload.names,
            email: payload.email,
            photoUrl: '',
            role: 'acheteur',
            phoneNumber: payload.telephone,
            id: auth
          })
            .then((snapshot) => {
              console.log('BEfoRE adding user detail ' + snapshot)
              commit('setUser', {
                names: payload.names,
                photoUrl: '',
                id: auth,
                email: payload.email,
                role: 'acheteur',
                phoneNumber: payload.telephone
              })
              if (getters.user.role === 'acheteur') {
                router.push('/')
              } else if (getters.user.role === 'producteur') {
                router.push('/console/producteur')
              } else {
                router.push('/')
              }
            })
            .catch((error) => {
              console.log('Error on firestore : => ' + error)
            })
            .catch((error) => {
              console.log('Error on user auth : => ' + error)
            })
        })
    },
    // sign user out from the app and clear the user state
    userSignOut ({commit}) {
      firebase.auth().signOut()
      commit('setUser', null)
      router.push('/')
    },
    ADD_ITEMS ({commit, state}, payload) {
      var found = false
      // Check if the item was already added to cart
      // If so them add it to the qty field
      state.shoppingCart.forEach(product => {
        if (product.productId === payload.productId) {
          found = true
          product.qty += payload.qty
        }
      })
      if (found === false) {
        state.shoppingCart.push(Vue.util.extend({}, payload))
      }
      payload.qty = 1
    },
    REMOVE_ITEM ({state}, payload) {
      var record = state.shoppingCart.find(product => product.productId === payload.productId)
      state.shoppingCart.splice(state.shoppingCart.indexOf(record), 1)
    },
    SAVE_SHOPPING_CART ({commit, state}, payload) {
      const cartItems = state.shoppingCart
      const userShoppingCart = []
      Array.from(cartItems).forEach(function (child) {
        userShoppingCart.push(child)
      })
      console.log(userShoppingCart)
      db.collection('shoppingCart').doc(state.user.email + 'shoppingCart' + state.user.id).set(arrayToObject(userShoppingCart))
        .then(() => {
          db.collection('shoppingCart').doc(state.user.email + 'shoppingCart' + state.user.id).get()
            .then((doc) => {
              const userShoppingCart = doc.data()
              commit('setShoppingCart', arrayToObject(userShoppingCart))
            })
        })
        .catch((error) => {
          console.log(error)
        })
    },
    PLACE_ORDER ({commit, state}, payload) {
      const cartItems = state.shoppingCart
      const orderList = []
      Array.from(cartItems).forEach(function (child) {
        orderList.push(child)
      })
      db.collection('orders').add({
        clientName: state.user.names,
        clientId: state.user.id,
        clientPhoneNumber: state.user.phoneNumber,
        orderStatus: false,
        article: orderList,
        amountToPay: payload})
        .then(ref => {
          console.log(ref.id)
          db.collection('shoppingCart').doc(state.user.email + 'shoppingCart' + state.user.id).delete()
            .then(res => {
              console.log(res)
              commit('setShoppingCart', [])
            })
        })
    },
    LOAD_SHOPPING_CART_ITEMS ({commit, state}, payload) {
      db.collection('shoppingCart').doc(payload.email + 'shoppingCart' + payload.uid).get()
        .then((doc) => {
          const userShoppingCart = doc.data()
          console.log('-----------------------------------' + payload.email + 'shoppingCart' + payload.uid + JSON.stringify(userShoppingCart))
          commit('setShoppingCart', Object.values(userShoppingCart))
        })
        .catch((error) => {
          console.log(error)
        })
    },
    SIGNUP_FACEBOOK ({commit, getters}) {
      var provider = new firebase.auth.FacebookAuthProvider()
      firebase.auth().useDeviceLanguage()
      firebase.auth().signInWithPopup(provider).then(function (result) {
        // The signed-in user info.
        var userId = result.user.uid
        var displayName = result.user.displayName
        var photoUrl = result.user.photoURL
        var phoneNumber = result.user.phoneNumber
        var email = result.user.email
        const userInfo = {
          email: email,
          role: 'acheteur',
          phoneNumber: phoneNumber,
          photoUrl: photoUrl,
          names: displayName,
          id: userId
        }
        const userObj = JSON.stringify(userInfo)
        var auth = firebase.auth().currentUser.uid
        console.log('About to save data in users collections ==================================== 0' + auth + email)
        console.log('About to save data in users collections ==================================== 1' + userObj)
        db.collection('users').doc(auth).set(userInfo)
          .then(() => {
            commit('setUser', userInfo)
            if (getters.user.role === 'acheteur') {
              router.push('/')
              console.log('Data saved in users and route redirect to /congo ==================================== 2')
            } else if (getters.user.role === 'producteur') {
              router.push('/console/producteur')
              console.log('Data saved in users and route redirect to /console/producteur ==================================== 2')
            } else {
              router.push('/connexion')
              console.log('Failed error  ==================================== 2')
            }
          })
      }).catch(function (error) {
        // Handle Errors here.
        var errorCode = error.code
        console.log(errorCode)
        var errorMessage = error.message
        console.log(errorMessage)
        // The email of the user's account used.
        var email = error.email
        console.log(email)
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential
        console.log(credential)
        // ...
      })
    },
    AUTO_SIGNIN ({commit, getters}, payload) {
      commit('setUser', {
        email: payload.email,
        role: payload.role,
        phoneNumber: payload.phoneNumber,
        photoUrl: payload.photoUrl,
        names: payload.displayName,
        id: payload.id
      })
      let auth = firebase.auth().currentUser.uid
      firebase.firestore().collection('users').doc(auth).get().then(function (doc) {
        commit('setUser', doc.data())
        if (getters.user.role === 'acheteur') {
          router.push('/')
          console.log('Data saved in users and route redirect to /congo ==================================== 2')
        } else if (getters.user.role === 'producteur') {
          router.push('/console/producteur')
          console.log('Data saved in users and route redirect to /console/producteur ==================================== 2')
        } else if (getters.user.role === 'administrateur') {
          router.push('/console/admin/dashboard')
          console.log('Data saved in users and route redirect to /console/ligablofood/administrateur ==================================== 2')
        } else {
          router.push('/connexion')
          console.log('Failed error  ==================================== 2')
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // Fetching user data from the firestore in the user collection
    FETCH_USER_DATA ({commit}) {
      let auth = firebase.auth().currentUser.uid
      firebase.firestore().collection('users').doc(auth).get().then(function (doc) {
        commit('setUser', doc.data())
      }).catch(error => {
        console.log(error)
      })
    },
    SIGNIN_USER ({state, commit, getters}, payload) {
      state.isLoading = true
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        .then(() => {
          let auth = firebase.auth().currentUser.uid
          firebase.firestore().collection('users').doc(auth).get().then(function (doc) {
            commit('setUser', doc.data())
            if (getters.user.role === 'acheteur') {
              router.push('/')
              console.log('Data saved in users and route redirect to /congo ==================================== 2')
            } else if (getters.user.role === 'producteur') {
              router.push('/console/producteur')
              console.log('Data saved in users and route redirect to /console/producteur ==================================== 2')
            } else if (getters.user.role === 'administrateur') {
              router.push('/console/admin/dashboard')
              console.log('Data saved in users and route redirect to /console/ligablofood/administrateur ==================================== 2')
            } else {
              router.push('/connexion')
              console.log('Failed error  ==================================== 2')
            }
          }).catch(error => {
            console.log(error)
          })
        })
      state.isLoading = false
    },
    SIGN_OUT ({commit}) {
      firebase.auth().signOut()
      commit('setUser', null)
      router.push('/')
    },
    REGISTER_PRODUCT ({commit}, payload) {
      const product = {
        productName: payload.productName,
        productProducer: payload.productProducer,
        category: payload.category,
        productPrice: payload.productPrice,
        soldAs: payload.soldAs,
        soldAsOf: payload.soldAsOf,
        productPricePerKgL: payload.productPricePerKgL,
        available: payload.available,
        discount: payload.discount,
        unit: payload.unit,
        qty: payload.qty,
        timestamp: new Date()
      }
      let productImageUrl
      let key
      // add product without its image
      db.collection('products').add(product)
        .then(docRef => {
          key = docRef.id
          return key
        })
        .then(key => {
          const productImage = payload.productImage.name
          const ext = productImage.slice(productImage.indexOf('.'))
          firebase.storage().ref('productImages/' + key + payload.productName + '.' + ext).put(payload.productImage)
            .then(snapshot => {
              return snapshot.ref.getDownloadURL()
            })
            .then(downloadUrls => {
              productImageUrl = downloadUrls
              db.collection('products').doc(key).update({productImg: productImageUrl, productId: key})
                .then(
                  commit('setProduct', {
                    product,
                    productImg: productImageUrl,
                    productId: key
                  }),
                  console.log('The product was uploaded'),
                  commit('setPublicDataLoaded')
                )
            })
            .catch(error => {
              console.log('Failed to upload product' + error)
            })
        })
        .catch(error => {
          console.log(error)
        })
    },
    REGISTER_PRODUCER ({commit}, payload) {
      const producer = {
        producerName: payload.producerName,
        state: payload.state,
        description1: payload.description1,
        description2: payload.description2,
        description3: payload.description3,
        email: payload.email,
        phoneNumber: payload.phoneNumber,
        timestamp: new Date()
      }
      let producerImageUrl
      let key
      // Add producer without image
      db.collection('producers').add(producer)
        .then(docRef => {
          key = docRef.id
          return key
        })
        .then(key => {
          const producerImage = payload.producerImage.name
          const ext = producerImage.slice(producerImage.indexOf('.'))
          firebase.storage().ref('producerImages/' + key + payload.producerName + '.' + ext).put(payload.producerImage)
            .then(snapshot => {
              return snapshot.ref.getDownloadURL()
            })
            .then(downloadUrls => {
              producerImageUrl = downloadUrls
              db.collection('producers').doc(key).update({producerImg: producerImageUrl})
                .then(
                  commit('setProducer', {
                    producer,
                    producerImg: producerImageUrl,
                    producerId: key
                  }),
                  console.log('The producer Image was successfully upload '),
                  commit('setPublicDataLoaded')
                )
            })
            .catch((error) => {
              console.log('Failed to upload the producer Image' + error)
            })
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  getters: {
    user (state) {
      return state.user
    },
    producers (state) {
      return state.producers
    },
    producerNameArray (state) {
      return state.producerNamesArray
    },
    categoryNamesArray (state) {
      return state.categoryNamesArray
    },
    products (state) {
      return state.products.sort((productA, productB) => {
        return productB.timestamp.seconds - productA.timestamp.seconds
      })
    },
    NKproducers (state) {
      return state.producers.filter(producer => producer.state === 'Nord Kivu')
    },
    SKproducers (state) {
      return state.producers.filter(producer => producer.state === 'Sud Kivu')
    },
    producer (state, payload) {
      return () => {
        return state.producers.filter(producer => producer.state === payload)
      }
    },
    shoppingCart (state) {
      return state.shoppingCart
    },
    productsOfCategory (state) {
      return keyword => state.products.filter(product => {
        return product.category === keyword
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js